<template>
  <div class="over_layout">
    <section class="upgrade">
      <a style="cursor: pointer" @click="$store.commit('paymentModal', true)">{{ $store.getters.t('create_resume') }}</a>
    </section>
    <section class="faq">
      <div class="wrapper">
        <div class="pages_header">
          <div class="lines">
            <h1>{{ $store.getters.t('FAQ') }}</h1>
          </div>
          <div class="description">
            <p>
              {{ translations[$store.getters.locale]['start'] }}
              <router-link :to="{name: 'contacts', params: {lang: $store.getters.locale }}">{{ translations[$store.getters.locale]['right_us'] }}</router-link>
              {{ translations[$store.getters.locale]['end'] }}
            </p>
          </div>
        </div>
      </div>
      <div class="questions_blocks">
        <div class="wrapper">
          <div
            class="block"
            v-for="item in faq"
            :key="item.id"
            :id="item['faq_transliations'][0]['slug']"
          >
            <div class="questions" @click="show">{{ item['faq_transliations'][0]['question'] }}</div>
            <div class="answer">
              <div class="text_area">
                <p v-html="item['faq_transliations'][0]['answer']"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="write_us">
        <div class="wrapper">
          <div class="form_block">
            <form method="POST" v-on:submit.prevent="sendQuestion">
              <input
                type="text"
                name="name"
                v-validate="'required|min:3'"
                :class="errors.first('name') ? 'invalid' : ''"
                class="inp_type"
                :placeholder="$store.getters.t('name')"
                required
              >
              <input
                type="email"
                name="email"
                v-validate="'required|email'"
                :class="errors.first('email') ? 'invalid' : ''"
                class="inp_type"
                :placeholder="$store.getters.t('email')"
                required
              >
              <textarea
                name="question"
                :class="errors.first('question') ? 'invalid' : ''"
                v-validate="'required'"
                :placeholder="$store.getters.t('write_us')"
              ></textarea>
              <input class="inp_send" type="submit" :value="$store.getters.t('send')">
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faq: [],
      translations: {
        am: {
          start: `Ուսումնասիրել, հավաքագրել և պատասխանել ենք այն հաճախ տրվող հարցերին,
                  որոնք հետաքրքիրեն բոլոր աշխատանք փնտրողներին: Հուսով ենք այստեղ կգտնեք ձեր բոլոր հարցերի պատասխանները:
                  Ձեր հարցերի պատասխանների մեծ մասը կարող եք գտնել այստեղ կամ`,
          link: "հաճախ տրվող հարցեր էջում:",
            right_us: "գրեք մեզ:",
          end: " Մենք միշտ ուրախ ենք Ձեզ օգնել:"
        },
        ru: {
          start: `Мы изучили и собрали те часто задаваемые вопросы, которые интересны соискателям, и ответили на них.
                  Надеемся здесь Вы найдете ответы на ваши вопросы.
                  Если у вас по-прежнему остались вопросы, `,
          link: "напишите нам,",
            right_us: "напишите нам.",
          end: "Мы всегда рады Вам помочь."
        },
        en: {
          start: `We studied and collected those frequently asked questions that are interesting to
                  applicants and answered them. We hope, that here you will find answers to your questions.
                  Still have questions?  Just `,
          right_us: "write to us.",
          link: "frequently asked questions ",
          end: "We are always happy to help you."
        }
      }
    };
  },
  mounted() {
    this.$parent.getData().then(changed => {
      if (changed) {
        this.getFAQ();
      }
    });
  },
  watch: {
    $route(to, from) {
      if (to.params.lang != from.params.lang) {
        this.$parent.getData().then(changed => {
          if (changed) {
            this.getFAQ();
          }
        });
      }
    }
  },
  methods: {
    getFAQ() {
      this.$http({
        method: "get",
        url: "/api/faq"
      })
        .then(res => {
          this.faq = res.data.FAQ;
          if (this.$route.hash) {
            setTimeout(() => {
              let element = document.getElementById(
                this.$route.hash.replace("#", "")
              );
              if (element) {
                let top = element.offsetTop;
                window.scrollTo({
                  top: top - 300,
                  left: 0,
                  behavior: "smooth"
                });
                element.children[0].click();
              }
            }, 250);
          }
        })
        .catch(err => {
          this.$parent.handleErrors(err);
        });
    },
    show(e) {
      this.$router.push({ hash: e.target.parentElement.id });

      let activeFaq = Array.prototype.slice.call(
        document.getElementsByClassName("block active")
      );
      activeFaq.forEach(element => {
        if (element.id !== e.target.parentElement.id) {
          element.classList.remove("active");
          element.classList.remove("active-faq");
        }
      });

      e.target.parentElement.classList.toggle("active");
      e.target.parentElement.classList.toggle("active-faq");
    },
    sendQuestion(form) {
      if (!this.errors.items.length) {
        let formData = new FormData(form.target);
        this.$http({
          method: "post",
          url: "/api/faq/send-question",
          data: formData
        })
          .then(res => {
            /* alert success message */
            this.$store.commit("newMessage", {
              show: true,
              type: "success",
              messageTitle: this.$store.getters.t("success"),
              message: this.$store.getters.t("text")
            });
          })
          .catch(err => {
            this.$parent.handleErrors(err);
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/Faq.vue